<template>
  <div class="timeline-items">
    <timeline-item
      v-for="(item, index) in items"
      :key="index"
      :item="item"
      :is-first="index === 0"
      :is-last="index === items.length - 1"
    />
    <div v-if="items.length === 0">{{ $t('user.timeline.no_items') }}</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get, maxBy, minBy, orderBy } from "lodash";
import * as moment from "moment";
import {
  addMomentJSDates,
  removeItemOverflow,
  getIncludedMoments,
  getIncludedCustomEvents
} from "./helpers";
import { mstohm } from "utils/time";
import TimelineItem from "./timeline-item/TimelineItem";

const currentDate = moment();

export default {
  name: "TimelineItems",
  components: {
    TimelineItem
  },
  computed: {
    ...mapState("user", {
      selectedDate: state => moment(state.day),
      eventHistory: state => addMomentJSDates(state.event_history),
      customEventHistory: state => addMomentJSDates(state.custom_event_history),
      momentHistory: state => addMomentJSDates(state.moment_history),
      predictions: state => {
        const events = get(state, "prediction_tree.events") || [];

        if (events.length === 0) {
          return [];
        }

        return addMomentJSDates(events);
      },
      items() {
        let items = this.combineItems(this.eventHistory, this.predictions);
        const dateBound = this.selectedDateBounds(items)
        items = items
          .map(item => {
            item = removeItemOverflow(item, dateBound);
            const _duration = item._end - item._start;
            const duration = mstohm(_duration);
            const moments = getIncludedMoments(item, this.momentHistory);
            const customEvents = getIncludedCustomEvents(
              item,
              this.customEventHistory
            );

            return { ...item, moments, customEvents, _duration, duration };
          })
          .filter(item => item._duration > 0);

        return items;
      }
    })
  },
  methods: {
    combineItems(events, predictions) {
      if (predictions.length === 0) {
        return events;
      }

      predictions = predictions.filter(item =>
        item._start.isSame(this.selectedDate, "day")
      );
      predictions = orderBy(predictions, "_start", "asc");

      return [...events, ...predictions];
    },
    selectedDateBounds(items) {
      if (!items.length) {
        const endOfDay = this.selectedDate.endOf('day');
        const startOfDay = this.selectedDate.startOf('day');

        return { startOfDay, endOfDay };
      }

      const lastItem = maxBy(items, 'start_ts');
      const firstItem = minBy(items, 'end_ts') || lastItem;
      const endOfDay = this.selectedDate
        .clone()
        .endOf("day")
        .utcOffset(lastItem._start.utcOffset(), true);
      const startOfDay = this.selectedDate
        .clone()
        .startOf("day")
        .utcOffset(firstItem._end.utcOffset(), true);

      return { startOfDay, endOfDay };
    }
  }
};
</script>

<style lang="scss" scoped>
.timeline-items {
  padding: 1.5rem 1rem;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
